/**
 * Méthode utilitaire qui aligne les divs des attributes des tuiles d'offres internet et mobile
 *
 * @param {Array.<String>} listOfDivToAlign liste des id des divs à aligner
 */
export function alignDivHeights(listOfDivToAlign) {
    listOfDivToAlign.forEach(function (divToFormat) {
        const divParagraphs = Array.from(document.querySelectorAll("." + divToFormat))
            .map((node) => node.parentNode);
        divParagraphs.forEach((paragraph) => paragraph.style.removeProperty("height"));
        const heightData = divParagraphs.reduce(function (accumulator, paragraph) {
            const jqParagraph = $(paragraph);
            return {
                jqParagraphs: accumulator.jqParagraphs.concat(jqParagraph),
                max: Math.max(accumulator.max, jqParagraph.height())
            };
        }, {jqParagraphs: [], max: 0});
        heightData.jqParagraphs.forEach((jqParagraph) => jqParagraph.height(heightData.max));
    });
}

/**
 * Méthode utilitaire qui aligne les divs se trouvant sur la même ligne
 *
 * @param {Array.<String>} listOfDivToAlign liste des ids des divs à aligner
 */
export function alignDivsHeightsByLine(listOfDivToAlign) {
    const showConsoleLogs = false;
    listOfDivToAlign.forEach(function (divToFormat) {
        const divParagraphs = Array.from(document.querySelectorAll("." + divToFormat))
            .map((node) => node.parentNode);
        divParagraphs.forEach((paragraph) => paragraph.style.removeProperty("height"));
        const heightData2 = divParagraphs.reduce(function (accumulator, paragraph) {
            const jqParagraph = $(paragraph);
            const paragraphY = paragraph.getBoundingClientRect().y;
            const actualJqParagraphsByY = accumulator.jqParagraphsByY.get(paragraphY);
            if (actualJqParagraphsByY) {
                accumulator.jqParagraphsByY.set(paragraphY, {
                    jqParagraphs: actualJqParagraphsByY.jqParagraphs.concat(jqParagraph),
                    max: Math.max(actualJqParagraphsByY.max, jqParagraph.height())
                });
            } else {
                accumulator.jqParagraphsByY.set(paragraphY, {
                    jqParagraphs: [].concat(jqParagraph),
                    max: Math.max(0, jqParagraph.height())
                });
            }
            return accumulator;
        }, {jqParagraphsByY: new Map()});

        if (showConsoleLogs && (heightData2.jqParagraphsByY.size > 1)) {
            console.log("[alignSameLineDivsHeights] multi line divToFormat = ", divToFormat)
            console.log("[alignSameLineDivsHeights] multi line heightData2 = ", heightData2)
        }

        for (let heightDataValue of heightData2.jqParagraphsByY.values()) {
            heightDataValue.jqParagraphs.forEach((jqParagraph) => jqParagraph.height(heightDataValue.max));
        }
    });
}

